<template>
  <div class="container">
    <!-- LANDING PAGE -->
    <div class="container-landing-page">
      <div class="col-hero-div">
        <div class="hero-text">
          <div class="hero-1">More&More Playing Cards</div>
          <div class="hero-tagline">for Imagining Different Worlds</div>
        </div>
        <div
          class="hero-image"
          alt="Image of a deck of Investing in Futures cards in their box, and a hand holding fanned out cards to it's right."
        ></div>
        <!-- DESKTOP ORDER NOW CTA START -->
        <div class="callout-container">
          <a href="https://moreandmorestore.bigcartel.com/" target="_blank">
            <div class="callout">
              <div class="callout2">
                <h1><span>ORDER A</span><br />PRINTED<br />DECK!</h1>
                click here
              </div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                version="1.1"
                id="Layer_1"
                x="0px"
                y="0px"
                width="200px"
                height="200px"
                viewBox="0 0 50 50"
                enable-background="new 0 0 50 50"
                xml:space="preserve"
              >
                <g>
                  <polygon
                    fill="#000000"
                    points="25,47 22.4,49.6 20.5,46.5 17.4,48.5 16.1,45.1 12.7,46.4 12.1,42.8 8.5,43.4 8.7,39.7 5.1,39.5 6.1,36 2.5,35.1 4.2,31.8 0.9,30.1 3.3,27.3 0.4,25 3.3,22.7 0.9,19.9 4.2,18.2 2.5,14.9 6.1,14 5.1,10.5 8.7,10.3 8.5,6.6 12.1,7.2 12.7,3.6 16.1,4.9 17.4,1.5 20.5,3.5 22.4,0.4 25,3 27.6,0.4 29.5,3.5 32.6,1.5 33.9,4.9 37.3,3.6 37.9,7.2 41.5,6.6 41.3,10.3 44.9,10.5 43.9,14 47.5,14.9 45.8,18.2 49.1,19.9 46.7,22.7 49.6,25 46.7,27.3 49.1,30.1 45.8,31.8 47.5,35.1 43.9,36 44.9,39.5 41.3,39.7 41.5,43.4 37.9,42.8 37.3,46.4 33.9,45.1 32.6,48.5 29.5,46.5 27.6,49.6"
                  />
                  <path
                    fill="#ffffff"
                    d="M27.529 0.798l1.669 2.615l0.273 0.428l0.424-0.28l2.583-1.706l1.093 2.907l0.178 0.475l0.473-0.185 L37.1 3.923l0.468 3.075l0.076 0.5l0.499-0.083l3.052-0.503l-0.179 3.107l-0.029 0.504l0.505 0.024l3.088 0.146l-0.816 3 l-0.132 0.486l0.486 0.128l2.993 0.79l-1.421 2.766l-0.23 0.448l0.449 0.227l2.765 1.398l-1.96 2.408l-0.317 0.39l0.392 0.3 L49.203 25l-2.416 1.944l-0.392 0.315l0.317 0.39l1.961 2.41l-2.766 1.399l-0.449 0.228l0.23 0.447l1.42 2.766l-2.991 0.8 l-0.488 0.128l0.133 0.486l0.817 3.003l-3.089 0.147l-0.505 0.023l0.029 0.504l0.179 3.104l-3.052-0.501l-0.499-0.082l-0.076 0.5 L37.1 46.074l-2.878-1.128l-0.473-0.185l-0.178 0.475l-1.093 2.909l-2.583-1.706l-0.424-0.28l-0.273 0.428l-1.669 2.6 l-2.173-2.208L25 46.632l-0.356 0.362l-2.173 2.208l-1.668-2.614l-0.273-0.429l-0.424 0.28l-2.583 1.706l-1.092-2.909l-0.178-0.475 l-0.473 0.185L12.9 46.075l-0.468-3.073l-0.076-0.5l-0.499 0.082l-3.05 0.501l0.177-3.104l0.029-0.504l-0.504-0.023L5.42 39.3 l0.818-3.002l0.132-0.487l-0.487-0.128l-2.992-0.789l1.419-2.766l0.229-0.447l-0.449-0.228L1.327 30.06l1.961-2.41l0.317-0.39 l-0.392-0.315L0.797 25l2.416-1.947l0.392-0.315l-0.317-0.39L1.327 19.94l2.764-1.398l0.449-0.227L4.31 17.867l-1.419-2.767 l2.992-0.79l0.487-0.128l-0.132-0.486L5.42 10.694l3.088-0.146l0.504-0.024l-0.029-0.504L8.807 6.913l3.05 0.503l0.5 0.1 l0.076-0.5L12.9 3.923l2.878 1.128l0.472 0.185l0.179-0.475l1.092-2.907l2.583 1.706l0.424 0.28l0.273-0.428l1.668-2.615 l2.173 2.208L25 3.368l0.356-0.362L27.529 0.8 M27.613 0L25 2.655L22.386 0L20.38 3.144l-3.106-2.051l-1.313 3.494L12.5 3.2 l-0.562 3.693L8.272 6.318l0.213 3.73l-3.711 0.175l0.981 3.604l-3.593 0.948l1.703 3.319l-3.318 1.679l2.353 2.89L0 25l2.9 2.3 l-2.353 2.892l3.318 1.68l-1.703 3.319l3.593 0.947l-0.981 3.604l3.711 0.177L8.272 43.68l3.666-0.603l0.562 3.691l3.461-1.356 l1.313 3.496l3.106-2.052L22.386 50L25 47.345L27.613 50l2.007-3.144l3.105 2.052l1.313-3.496l3.461 1.356l0.562-3.691l3.668 0.6 l-0.215-3.728l3.711-0.177l-0.98-3.604l3.594-0.947l-1.705-3.319l3.319-1.68l-2.353-2.892L50 25l-2.899-2.336l2.353-2.89 l-3.319-1.679l1.705-3.319l-3.594-0.948l0.98-3.604l-3.711-0.175l0.215-3.73l-3.668 0.604L37.5 3.229l-3.461 1.357l-1.313-3.494 L29.62 3.144L27.613 0L27.613 0z"
                  />
                </g>
              </svg>
            </div>
          </a>
        </div>
        <!-- DESKTOP ORDER NOW CTA END -->
      </div>
      <div class="col-zig-zag"></div>
      <div class="col-deck-selection-div">
        <div class="hero-text">
          <div class="select-deck-header">Choose a deck to start</div>
          <div class="select-deck-subheader">
            Each digital deck includes unique cards and basic how-to-play guide!
          </div>
          <div
            class="ziggyzig-arrow"
            role="presentation"
            alt="A squiggly downward-pointing arrow."
          ></div>
        </div>
        <div class="deck-loading" v-if="!decksFetched">
          <span class="loading-animation loading-text">LOADING DECKS ...</span>
        </div>
        <div class="deck-lineup" v-if="decksFetched">
          <div
            v-for="deck in publishedDecks"
            class="deck-button"
            :key="deck.name"
            :class="deck.isSelected ? 'selected' : ''"
            @mousedown="openDeck(deck.name)"
          >
            <div class="deck-art">
              <!-- SVG deck box -->
              <svg width="160" height="211" xmlns="http://www.w3.org/2000/svg">
                <g fill="none" fill-rule="evenodd">
                  <path
                    v-if="deck.boxColor"
                    :fill="deck.boxColor"
                    d="M0 .287v196.438l17.439 13.268 142.561.229V13.784L142.561.287z"
                  />
                  <path
                    v-if="!deck.boxColor"
                    fill="#66BFC0"
                    d="M0 .287v196.438l17.439 13.268 142.561.229V13.784L142.561.287z"
                  />
                  <path
                    fill-opacity=".15"
                    fill="#000"
                    style="mix-blend-mode: multiply"
                    d="M142.561.287L160 13.784v196.438l-17.439-13.497z"
                  />
                  <path
                    fill-opacity=".3"
                    fill="#000"
                    style="mix-blend-mode: multiply"
                    d="M0 196.725h142.561L160 209.993H17.439z"
                  />
                </g>
              </svg>
              <!-- END SVG deck box -->
              <div v-if="deck.rawSvg" class="deck-art-icon">
                <svg
                  version="1.1"
                  id="Layer_1"
                  xmlns="http://www.w3.org/2000/svg"
                  x="0"
                  y="0"
                  viewBox="0 0 123 122"
                  xml:space="preserve"
                  :style="{
                    fill: deck.iconColor,
                  }"
                  v-html="deck.rawSvg"
                ></svg>
                <!-- fallback deck icon SVG begin -->
                <div v-if="!deck.rawSvg" class="deck-art-icon">
                  <svg
                    version="1.1"
                    id="Layer_1"
                    xmlns="http://www.w3.org/2000/svg"
                    x="0"
                    y="0"
                    viewBox="0 0 123 122"
                    xml:space="preserve"
                    style="
                       {
                        fill: #e03f3f;
                      }
                    "
                  >
                    <path
                      class="st0"
                      d="M64.6.7c1.5.2 3 .3 4.5.6 10.6 1.4 20.7 5.6 29.1 12.2 12.3 9.5 19.5 22.1 22.3 37.3 1.2 6.6 1.2 13.3.1 19.9-.6 3.5-1.4 6.9-2.6 10.2-.2.6-.1.8.4 1 1.3.5 2.7 1 4.2 1.5-4.1 4-8.8 7.3-14 9.8.4-5.2-.1-10.3-1.3-15.4 1.4.5 2.7.9 3.8 1.4.9.4 1.2.1 1.4-.7 1.2-3.5 2-7.1 2.5-10.7 1.4-10.4-.4-21.1-5.1-30.5-7.4-15.1-19.5-24.6-35.6-29-4.5-1.2-9.2-1.8-13.8-1.7-4.1.1-8.2.6-12.1 1.6-.9.2-1.3.1-1.5-.9-.2-1.3-.6-2.6-1-3.9-.2-.6-.1-.8.6-.9 3.6-.9 7.3-1.4 11-1.7.3 0 .7.1 1-.2h6.1zM.4 37C3 34.6 5.9 32.5 9 30.7c1.6-1 3.4-1.8 5-2.7.5-.3.7-.3.6.4-.3 4.1-.1 8.3.5 12.4.1.7.3 1.4.4 2.2-1.4-.6-2.7-1-4-1.6-.6-.3-.8-.2-1 .5-2.8 7.4-4 15.4-3.4 23.3 1 13.3 6.9 25.8 16.5 35.1s22.3 14.7 35.7 15.1c3.4.1 6.7-.1 10-.6.6-.1.8.2.9.7.2 1.5.5 3 .7 4.5.1.5-.1.6-.6.7-4.1.6-8.3.8-12.4.6-8.1-.4-16-2.5-23.3-6.1-7.3-3.6-13.7-8.6-19-14.8C8.3 92 3.5 81.8 1.7 70.8c-1.5-9.4-.8-19 2.1-28 .3-1 .8-2.1 1.2-3.2.2-.5.2-.8-.4-1-1.5-.5-2.8-1-4.2-1.6z"
                    />
                    <path
                      class="st0"
                      d="M100 55.6v-4.1H79.4v4.1l8 1.3c-1.7 7.4-4.5 14.5-8.5 21L78 77c3.4-5.9 5.9-12.4 7.4-19l-8-1.3v-4.1h-3v4.1l8 1.3c-1.3 5.9-3.4 11.7-6.2 17-2.9-3.2-5.8-6.2-9-9.7-3.5-3.8-6-6.6-8.2-9 10.5-5.6 15.2-10.5 15.2-17.6 0-7.7-5.5-13-15.5-13-2.5 0-4.8.4-6.8 1.1C43.2 27.2 37 32.6 37 41c0 5.4 1.9 10.6 7 16.4.2.2.3.4.5.5-10.2 5-15.5 11.9-15.5 21 0 10.3 8.8 18.6 21.5 18.6.6 0 1.2 0 1.7-.1-12-.5-20.2-8.5-20.2-18.5 0-9.1 5.3-16 15.4-21.1l-.5-.5c-5.1-5.8-7-11-7-16.4 0-6.2 3.4-10.7 8.7-12.9-4 2.5-6.6 6.6-6.6 12s1.9 10.6 7 16.4c.2.2.3.4.5.5-10.2 5-15.5 11.9-15.5 21 0 10.3 8.8 18.6 21.5 18.6 7.6 0 13.3-2.3 17.5-5.7.6.6 1.2 1.3 1.8 2 3.4 3.5 6.6 4.7 11.9 4.7.5 0 .9 0 1.4-.1-4.4-.2-7.2-1.6-10.3-4.7-1.1-1.2-2.1-2.3-3.1-3.4l1.5-1.5c1.1 1.3 2.3 2.6 3.6 4 3.4 3.5 6.6 4.7 11.9 4.7 2.6 0 5.2-.4 7.8-1l.4-4.4-9.9-1.4c-3.1-3.3-5.8-6.2-8.4-8.9 4.9-7.3 8.4-15.4 10.5-23.9l7.9-1.3zM63 72.9c3.4 3.8 6.7 7.5 10.4 11.7-1.6 1.3-3.4 2.4-5.4 3.3 1.2-.7 2.3-1.5 3.3-2.3-3.7-4.1-7-7.9-10.4-11.7-4.6-5.4-7.6-9.1-10.9-12.9l1.8-1.2c3.4 3.8 6.5 7.5 11.2 13.1zM49.4 38.6c0-1.2.2-2.5.6-3.6.4-1.1 1.1-2.2 2-3.1.9-.9 1.9-1.6 3-2.1s2.4-.7 3.6-.7c5 0 8.8 3.6 8.8 9.5S63 49.1 56.6 53.4c-.1-.1-.2-.2-.2-.3 5.4-4 9-8.2 9-13.6 0-5.9-3.8-9.5-8.8-9.5-.5 0-1 0-1.5.1 4.3.7 7.3 4.1 7.3 9.4 0 4.7-2.8 8.5-7.2 12.1-.4-.5-.9-1.1-1.4-1.7-3.6-4.6-4.4-7.7-4.4-11.3zm-6.6 36.6c0-4.1 1.3-8.8 5.5-12.7 2.8 3.3 5.6 6.7 9.6 11.5 3.4 3.8 6.7 7.5 10.4 11.7-2.2 1.9-4.8 3.4-7.8 4.3-.7-.1-1.5 0-2.3 0-9.8 0-15.4-7.4-15.4-14.8z"
                    />
                    <path
                      class="st1"
                      d="M92.4 86.4c-.1 0-.2-.1-.2-.1l-1.7-2.1c-.3-.3-.2-.3-.6-.1l-2.4 1-.2.1h-.1v-.1l.5-.4c.6-.5 1.1-.9 1.7-1.4l.1-.1.1-.1v-.2c0-.1 0-.1-.1-.1-.4-.9-.7-1.7-1.1-2.6 0-.1-.1-.2 0-.2s.1.1.1.1l1.7 2.1c.2.3.2.3.6.2l2.5-1c.1 0 .2-.1.2 0s-.1.1-.1.2l-2.1 1.7c-.3.2-.3.2-.1.6.3.8.7 1.7 1 2.5.1-.1.2 0 .2 0M27.8 50.5c.6.6 1.1 1.3 1.6 2s.4.6 1.1.3l2.2-.9c.1 0 .2-.1.2-.1 0 .1-.1.1-.1.2l-2.2 1.7c-.3.2-.3.2-.2.6.4.9.7 1.7 1.1 2.6 0 0 .1.1 0 .2-.1 0-.1-.1-.1-.1-.6-.8-1.2-1.5-1.8-2.2l-.1-.1-.1-.1h-.1s-.1 0-.1.1c-.8.4-1.7.7-2.5 1-.1 0-.2.1-.2.1 0-.1.1-.1.1-.2.7-.6 1.4-1.2 2.2-1.7l.1-.1s0-.1.1-.1v-.1-.1c-.4-.9-.7-1.7-1.1-2.6-.1-.3-.1-.3-.1-.4M84 29.6c-.1.2-.3.3-.5.5-1.1.9-2.1 1.7-3.2 2.5-.2.2-.2.3-.1.6.5 1.3 1.1 2.6 1.6 3.8 0 .2.3.4.1.5-.2.1-.2-.2-.4-.4-.9-1.1-1.7-2.1-2.5-3.2-.2-.3-.4-.3-.7-.2-1.3.5-2.7 1.1-4 1.6-.1 0-.2.1-.2 0-.1-.1.1-.1.1-.2l3.3-2.6c.5-.4.5-.4.3-.9-.4-1.1-.9-2.2-1.3-3.3-.2-.3-.2-.6-.2-.9 1 1.2 1.9 2.3 2.9 3.5.4.4.4.4.9.2l3.8-1.5h.1z"
                    />
                  </svg>
                </div>
                <!-- fallback SVG end -->
              </div>
            </div>
            <div class="deck-name" :class="deck.isSelected ? 'selected' : ''">
              {{ deck.name }}
            </div>
            <div
              class="created-by"
              v-if="deck.name != 'Original' && deck.name != 'What If?'"
            >
              edition designed with
            </div>
            <div class="deck-creator-name">{{ deck.creator }}</div>
            <p class="blurb">{{ deck.blurb }}</p>
          </div>
        </div>
        <!-- MOBILE CTA TO BUY PRINTED DECKS -->
        <div class="order-printed-CTA">
          Printed decks can be ordered at the
          <a href="https://moreandmorestore.bigcartel.com/" target="_blank"
            >More&More&nbsp;Store</a
          >.
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import { getAllDecks } from "@/services/DeckService.js";
import deckData from "../data/deck_data.json";
export default {
  name: "Deck Picker",
  data() {
    return {
      decksFetched: true,
      selectedDeck: undefined,
      decks: deckData,
    };
  },
  methods: {
    setAsSelected(targetDeckName) {
      this.selectedDeck = targetDeckName;
      for (var i = 0; i < this.decks.length; i++) {
        if (this.decks[i].name !== targetDeckName) {
          this.decks[i].isSelected = false;
        } else {
          this.decks[i].isSelected = true;
        }
      }
    },
    openDeck(targetDeckName) {
      this.setAsSelected(targetDeckName);
      if (targetDeckName === "What If?") {
        this.goToWhatIf();
      } else {
        this.$router.push({
          name: "GameMain",
          params: { deckId: this.selectedDeck },
        });
      }
    },
    goToWhatIf() {
      this.$router.push({
        name: "SingleCardPicker",
        params: { deckId: "What If?" },
      });
    },
  },
  computed: {
    publishedDecks() {
      return this.decks.filter((deck) => deck.published === true);
    },
    validDeckSelected() {
      return this.selectedDeck === undefined ? false : true;
    },
    userSelectedDeck() {
      return this.selectedDeck;
    },
  },
};
</script>
<style scoped>
/* PAGE STRUCTURE */
.container-landing-page {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  /* height: calc(100vh - 4.5rem); */
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  background: linear-gradient(180deg, #309b9d 0%, #63c7c9 32.5%), #63c7c9;
}
.col-hero-div {
  position: relative;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  width: 100%;
  min-height: 100vh;
  box-sizing: border-box;
  background-color: var(--var-IIF-teal);
  align-items: center;
  justify-content: flex-start;
  padding-top: 6rem;
  background-image: url("../assets/bigCartelBG.png");
  background: url("../assets/bigCartelBG.png");
  background-size: cover;
  overflow-y: scroll;
  -ms-overflow-style: -ms-autohiding-scrollbar;
}

.col-deck-selection-div {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-grow: 1;
  width: 100%;
  padding-top: 8rem;
  box-sizing: border-box;
  background: #e9e9e9;
  background-size: 50%;
  overflow-y: scroll;
}

/* HERO COLUMN TYPOGRAPHY & IMGS */
.hero-text {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 80%;
}

.hero-1 {
  padding: 0;
  margin: 0 0 2rem 0;
  font-size: 6rem;
  line-height: 5.6rem;
  text-transform: uppercase;
  font-weight: bold;
  letter-spacing: -0.35rem;
  color: black;
  text-align: center;
}

.hero-tagline {
  font-size: 3rem;
  color: black;
  letter-spacing: -0.1rem;
  margin-bottom: 4rem;
  text-align: center;
}
/* .hero-blurb {
  color: var(--var-IIF-darker-teal);
  font-size: 1.75rem;
  line-height: 1.8rem;
  font-weight: bold;
  font-style: oblique;
  text-transform: uppercase;
  text-align: left;
  box-sizing: border-box;
  max-width: 57.5rem;
  background: #bdf6f8;
  margin-top: 2rem;
  padding: 1rem;
  border-radius: 0.5rem;
  border: 5px solid #309b9d;
  box-sizing: border-box;
  box-shadow: -3px 3px 0px #309b9d;
  transform: rotate(-3deg);
} */

.hero-blurb {
  color: var(--var-IIF-blue);
  font-size: 2.2rem;
  line-height: 2.1rem;
  font-weight: bold;
  text-transform: uppercase;
  text-align: center;
  box-sizing: border-box;
  margin-bottom: 2rem;
  max-width: 66rem;
}
.hero-blurb strong {
  font-weight: bolder;
  text-shadow: -0.2rem 0.2rem 0 var(--var-IIF-cyan);
}
p {
  font-family: Helvetica, Arial, sans-serif;
  text-align: left;
  text-align: justify;
  margin-bottom: 0.1rem;
  max-width: 450px;
  color: var(--var-IIF-blue);
}
.hero-image {
  width: 338px;
  height: 373px;
  min-height: 300px;
  background-image: url("../assets/IIF_hand_image-transparent.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}

/* CTA CALL OUT BADGE DESKTOP*/
.callout-container {
  display: none;
  position: fixed;
  z-index: 100;
  left: 20%;
  top: 80%;
  transform: rotateZ(-10deg);
}
.callout .callout2 {
  position: absolute;
  text-align: center;
  height: 190px;
  width: 190px;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  color: white;
}
.callout > svg {
  position: absolute;
  top: -100px;
  left: -5px;
  z-index: -1;
  -webkit-animation: rotation 30s infinite;
  animation: rotation 30s infinite;
  animation-timing-function: linear;
}

/* Order Printed CTA */
.order-printed-CTA {
  margin: 6rem 2rem 10rem 2rem;
  padding: 2rem;
  font-size: 2.2rem;
  font-family: var(--var-IIF-sans-body);
  text-align: center;
}
.order-printed-CTA a,
.order-printed-CTA a:hover {
  font-weight: bold;
  color: black;
}

@-webkit-keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

h1 {
  font-family: var(--var-IIF-sans-heavy);
  text-transform: uppercase;
  font-size: 30px;
  line-height: 1;
  font-weight: 300;
  margin: 45px 0 0;
}
h1 > span {
  font-size: 20px;
}

/* SELECT A DECK TYPOGRAPHY & IMGS */
.select-deck-header {
  color: black;
  font-family: (--var-IIF-sans-body);
  font-size: 5rem;
  font-weight: bold;
  text-transform: uppercase;
  text-align: center;
  letter-spacing: -0.3rem;
}
.select-deck-subheader {
  font-size: 2.3rem;
  text-align: center;
}
.ziggyzig-arrow {
  min-height: 7rem;
  width: 1rem;
  margin: 1rem;
  background: url("../assets/ZiggyZig-black.png");
  background-repeat: no-repeat;
  background-position: fixed;
  background-size: contain;
}

/* DECKS LOADING STYLES */
.deck-loading {
}
@keyframes flickerAnimation {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@-o-keyframes flickerAnimation {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@-moz-keyframes flickerAnimation {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@-webkit-keyframes flickerAnimation {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.loading-animation {
  -webkit-animation: flickerAnimation 2s infinite;
  -moz-animation: flickerAnimation 2s infinite;
  -o-animation: flickerAnimation 2s infinite;
  animation: flickerAnimation 2s infinite;
}
.loading-text {
  font-size: 4rem;
}

/* DECK BUTTON STYLES */
.deck-lineup {
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex-wrap: wrap;
  z-index: 3;
}
.deck-button {
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 1rem;
  padding: 2rem;
  box-sizing: border-box;
  border-radius: 20px;
  border: 5px solid transparent;
  width: 30%;
  min-width: 300px;
}
.deck-button:hover,
.deck-button.selected {
  background: white;
  box-shadow: 0px 0px 0px 3px #000;
  transform: translateX(-3px);
}
.deck-button:hover > *,
.deck-button.selected > * {
  /* color: white; */
}
.deck-button:hover .deck-art,
.deck-button.selected .deck-art {
  filter: drop-shadow(0px 4px 25px Univers-black);
  filter: drop-shadow(4px 8px 10px white);
  transform: rotateZ(-3deg);
}
.deck-art {
  position: relative;
  width: 160px;
  height: 210px;
  background-repeat: no-repeat;
  background-size: contain;
  margin-top: 1rem;
  margin-bottom: 1rem;
  text-align: left;
  transition: transform 0.2s ease-in-out;
}
.deck-art-icon {
  position: absolute;
  box-sizing: border-box;
  width: 120px;
  height: 120px;
  top: 4rem;
  left: 1.2rem;
}
.deck-name {
  font-size: 2.7rem !important;
  text-align: center;
  font-weight: bolder;
  text-transform: uppercase;
  margin-bottom: 1rem;
  letter-spacing: -0.1rem;
  color: black;
}
.created-by {
  font-family: var(--var-IIF-sans-body);
  font-size: 1rem;
  color: #2c3e50;
  opacity: 0.5;
  text-align: center;
  text-transform: uppercase;
  margin: 0.2rem auto 0.5rem auto;
}
.deck-creator-name {
  font-family: var(--var-IIF-sans-body);
  font-size: 1.4rem;
  text-align: center;
  text-transform: uppercase;
  font-weight: bold;
  margin: 0.2rem auto 0.2rem auto;
  color: black;
}
.blurb {
  font-family: var(--var-IIF-sans-body);
  font-size: 1.6rem;
  line-height: 2rem;
  color: black;
  text-align: center;
}

/* BUTTONS */
.button-div {
  margin-top: 4rem;
  margin-bottom: 10rem;
}
button {
  font-family: var(--var-IIF-sans-heavy);
  border: 0;
  background-color: var(--var-IIF-teal);
  color: var(--var-IIF-blue);
  text-transform: uppercase;
  font-weight: bolder;
  margin: 1rem;
  padding: 1.8rem 2.8rem 1.5rem 2.8rem;
  font-size: 1.4rem;
}
button:hover {
  transform: translate(0, -4px);
  box-shadow: 0 4px var(--var-IIF-blue);
}
button:active {
  /* transform: translate(0, 4px); */
  box-shadow: 0 -4px var(--var-IIF-blue);
  padding-bottom: calc(1.2rem - 4px);
  margin-top: calc(1rem + 4px);
}
button:disabled {
  opacity: 0.5;
}

/* Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) {
}

/* Medium devices (tablets, 768px and up) */
@media (min-width: 768px) {
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) {
  .container-landing-page {
    flex-direction: row;
  }
  .col-hero-div {
    width: 30%;
    background-size: cover;
    background-attachment: fixed;
  }

  .col-deck-selection-div {
    width: calc(70% - 32px);
  }

  .callout-container {
    display: block;
  }
  .order-printed-CTA {
    font-size: 1.8rem;
  }
}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
}
</style>
